<script>
// export const groupId = 'group-' + Math.random().toString(36).substring(2, 15)
</script>

<script setup>
const props = defineProps({
  item: Array,
})

const itemComponentAActive = ref(false)

const itemComponentA = shallowRef(null)
const itemComponentB = shallowRef(null)

// The counters are used to give the components a unique key, needed when we switch between two items
const itemComponentACounter = ref(null)
const itemComponentBCounter = ref(null)

watch(
  () => props.item[props.item.length - 1], // The highest scene layer is on top of the items array.
  (newItem, oldItem) => {
    const isNew = !oldItem || newItem.item.id !== oldItem.item.id
    if (isNew) {
      if (itemComponentAActive.value) {
        itemComponentBCounter.value = itemComponentBCounter.value + 1
      } else {
        itemComponentACounter.value = itemComponentACounter.value + 1
      }
      itemComponentAActive.value = !itemComponentAActive.value
    }

    if (itemComponentAActive.value) {
      itemComponentA.value = newItem
    } else {
      itemComponentB.value = newItem
    }
  },
  { immediate: true }
)
</script>

<template>
  <div class="w-full h-full">
    <component
      :is="itemComponentA.component"
      v-if="itemComponentA"
      :key="itemComponentA.item.id + '--' + itemComponentACounter"
      :disappearKey="itemComponentA.key"
      :item="itemComponentA.item"
      class="absolute"
      :class="{ 'z-10': itemComponentAActive }"
    />
    <component
      :is="itemComponentB.component"
      v-if="itemComponentB"
      :key="itemComponentB.item.id + '--' + itemComponentBCounter"
      :disappearKey="itemComponentB.key"
      :item="itemComponentB.item"
      class="absolute"
      :class="{ 'z-10': !itemComponentAActive }"
    />
  </div>
</template>
